import {ActionType} from "typesafe-actions";
import IAnalyticsAction from "../IAnalyticsAction";
import {trackAction} from "../../actions";

export default function trackActionHandler(action: ActionType<typeof trackAction>): IAnalyticsAction | undefined {
    return action.payload;
}